export const COMPANY = {
  name: "Asset Group Pte Ltd",
  shortName: "Asset Group",
  tagline: "Build. Grow. Prosper.",
  contactPerson: "Mr Jona Divavesi",
  phone: "+679 9246606",
  phoneRaw: "+6799246606",
  email: "projects@assetgroup.com.fj",
  address: "MSC Road, Wailoku, Tamavua, Suva, Fiji",
  industry: "Construction, Building & Civil Works",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_fiji-asset-builds/artifacts/nan1r861_ChatGPT%20Image%20Jun%208%2C%202026%2C%2007_06_27%20PM.png",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Projects", path: "/projects" },
  { label: "Contact", path: "/contact" },
];

export const SERVICES = [
  {
    slug: "residential",
    title: "Residential Construction",
    short: "Quality family homes built to last in Fiji's climate.",
    description:
      "From foundation pour to handover, we build durable, beautiful residences engineered for tropical conditions. Custom designs, robust block-work, and finishes that elevate everyday living.",
    image:
      "https://images.pexels.com/photos/12843084/pexels-photo-12843084.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    points: ["New family homes", "Multi-storey dwellings", "Block & timber construction", "Turn-key handover"],
  },
  {
    slug: "commercial",
    title: "Commercial Construction",
    short: "Offices, retail and industrial builds delivered on time.",
    description:
      "We deliver commercial projects with precision — offices, retail spaces, warehouses, and workshop facilities. Built for compliance, productivity and longevity.",
    image:
      "https://images.pexels.com/photos/3818947/pexels-photo-3818947.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    points: ["Office fit-outs", "Retail buildings", "Warehouses & workshops", "Tenancy works"],
  },
  {
    slug: "renovations",
    title: "Renovations & Maintenance",
    short: "Refresh, restore and extend with confidence.",
    description:
      "Whether a kitchen refresh, structural extension, or scheduled facility maintenance — we deliver clean, careful work that protects the value of your asset.",
    image:
      "https://customer-assets.emergentagent.com/job_fiji-asset-builds/artifacts/54wcpeu2_8e2478dc-b178-496b-8590-a22bb19036d9.jpeg",
    points: ["Extensions & remodels", "Kitchen & bathroom upgrades", "Structural repairs", "Scheduled maintenance"],
  },
  {
    slug: "civil-works",
    title: "Civil Works",
    short: "Earthworks, drainage and site infrastructure.",
    description:
      "Excavation, drainage, retaining structures, access roads and site preparation. Heavy-machinery capability with experienced operators.",
    image:
      "https://customer-assets.emergentagent.com/job_fiji-asset-builds/artifacts/696v8i3e_f360641d-97b2-4a2f-b43c-7b9ba95db949.jpeg",
    points: ["Excavation & earthworks", "Drainage & culverts", "Access roads", "Retaining walls"],
  },
  {
    slug: "project-management",
    title: "Project Management",
    short: "End-to-end oversight that keeps projects on budget.",
    description:
      "Programme management, sub-contractor coordination, procurement, quality assurance and reporting. We translate plans into delivered outcomes.",
    image:
      "https://images.pexels.com/photos/8470842/pexels-photo-8470842.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    points: ["Programme & scheduling", "Budget control", "QA / HSE oversight", "Client reporting"],
  },
  {
    slug: "consultancy",
    title: "Building Consultancy",
    short: "Practical advice from feasibility to compliance.",
    description:
      "Feasibility studies, costings, technical reviews, compliance checks and pre-tender support. We help you make confident decisions before breaking ground.",
    image:
      "https://customer-assets.emergentagent.com/job_fiji-asset-builds/artifacts/pptux4l5_98895118-7707-4690-b153-d809cb439c8e.jpeg",
    points: ["Feasibility studies", "Cost estimating", "Technical reviews", "Compliance & permits"],
  },
];

export const VALUES = [
  { num: "01", title: "Build", body: "We construct enduring structures with disciplined craft and the right materials." },
  { num: "02", title: "Grow", body: "We help our clients' assets — and our communities — grow in value over time." },
  { num: "03", title: "Prosper", body: "Reliable delivery turns blueprints into prosperous outcomes for everyone." },
];
